module.exports = __webpack_public_path__ + "img/08.7a991f61.jpg";